import React, { ComponentType, useEffect, useState } from 'react'

import { WIDGET_MARKETPLACE_WINDOW_ID } from '../components/WidgetMarketplace/WidgetMarketplace.constants'

export interface RestorableLocalWindowDefinition {
  id: string
  title: string
  canMaximize: boolean
  canMinimize: boolean
  canSnap: boolean
  localComponent: () => JSX.Element
}

// Loaded via a dynamic import, not a static one: this module is part of the
// core window-store barrel, evaluated very early. A static import of
// WidgetMarketplace would pull in the whole widget catalog (widgetsConfig,
// every widget component, AI artifacts + forge API) as part of that early
// load — and since WidgetMarketplace, the widget catalog, and the sidebar
// all reference each other, that closes a real module-init cycle (verified
// with madge) that can leave `AiArtifactTileWidget` undefined depending on
// evaluation order. Deferring the require until the window is actually
// restored avoids the cycle entirely.
const LazyWidgetMarketplace = () => {
  const [Component, setComponent] = useState<ComponentType | null>(null)

  useEffect(() => {
    let cancelled = false
    import('../components/WidgetMarketplace/WidgetMarketplace').then(module => {
      if (!cancelled) setComponent(() => module.WidgetMarketplace)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return Component ? <Component /> : null
}

export const restorableLocalWindows: Record<
  string,
  RestorableLocalWindowDefinition
> = {
  [WIDGET_MARKETPLACE_WINDOW_ID]: {
    id: WIDGET_MARKETPLACE_WINDOW_ID,
    title: 'Widget Marketplace',
    canMaximize: false,
    canMinimize: false,
    canSnap: false,
    localComponent: () => <LazyWidgetMarketplace />
  }
}
